import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=5f0480b8"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"
import style0 from "./customButton.vue?vue&type=style&index=0&id=5f0480b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports